/**
 * Signin
 * Page/Class name   : Signin
 * Author            :
 * Created Date      : 10-2-2020
 * Functionality     : Signin
 * Purpose           : render Signup component
**/
import React, {Component} from 'react';
import PropTypes from 'prop-types';

import UserLoginService from '../../service/UserLoginService';
import LoggedinUserInfoService from '../../service/LoggedinUserInfoService';
import CustLoader from '../after_login/CustLoader';
import { withRouter } from "react-router-dom";

// for notification
// import { store } from 'react-notifications-component';
import {commonJsFuncModule as commonJsObj} from  '../../../common_utilities/commonjsfunc';
import {notify} from '../../messagebar/CustomMessageBar';


const custEncode = commonJsObj.custEncode;
const removeUserInfoBeforeLogin = commonJsObj.removeUserInfoBeforeLogin;

class Signin extends Component {

  isComponentLoaded = false;

  /**
   * Signin
   * Function name : constructor
   * Author        :
   * Created Date  : 10-2-2020
   * Purpose       : initializing state
   * Params        : props
  **/
  constructor(props) {
      super(props);

      this.state = {
        emailId: '',
        emailIdErMsg: '',
        password: '',
        passwordErMsg: '',
        loaderFlag: false,
        tokenRespData: {},
        loggedInUserInfoResp: {},
      }

  }

  /**
     * Signin
     * Function name : componentDidMount
     * Author        :
     * Created Date  : 10-2-2020
     * Purpose       : life cycle method
     * Params        :
    **/
  componentDidMount() {
      this.isComponentLoaded = true;
  }

  handlePlaceChanged(){
    const place = this.autocomplete.getPlace();
    this.props.onPlaceLoaded(place);
  }

  /**
     * Signin
     * Function name : componentWillUnmount
     * Author        :
     * Created Date  : 10-2-2020
     * Purpose       : life cycle method
     * Params        :
    **/
   componentWillUnmount() {
    this.isComponentLoaded = false;
  }

  /**
   * Signin
   * Function name : showLoader
   * Author        :
   * Created Date  : 10-2-2020
   * Purpose       : Used to show loader
   * Params        :
  **/
  showLoader(){
    this.isComponentLoaded && this.setState({loaderFlag: true});
  }

  /**
   * Signin
   * Function name : hideLoader
   * Author        :
   * Created Date  : 10-2-2020
   * Purpose       : Used to hide loader
   * Params        :
  **/
  hideLoader(){
    this.isComponentLoaded && this.setState({loaderFlag: false});
  }

  /**
   * Signin
   * Function name : loadLoader
   * Author        :
   * Created Date  : 10-2-2020
   * Purpose       : Used to load loader
   * Params        :
  **/
  loadLoader(){
      return (
                <CustLoader className={'miniButnLoaderWhite'} loaderText={''}  />
      );
  }

  /**
   * Signin
   * Function name : handleChange
   * Author        :
   * Created Date  : 10-2-2020
   * Purpose       : Used to handle change event
   * Params        :
  **/
  handleChange = (e) => {
  this.isComponentLoaded &&  this.setState({[e.target.name]: e.target.value});
  }

   /**
   * Signin
   * Function name : custValidate
   * Author        :
   * Created Date  : 12-2-2020
   * Purpose       : validate data before submit
   * Params        :
  **/
  custValidate = ()=>{

    let emailIdErMsg = '';
    let passwordErMsg = '';
    let totErrCountTrack = [];
    let regexBlankSpace = /^ *$/;

    if(!(this.state.emailId)||(this.state.emailId.length==0)|| (regexBlankSpace.test(this.state.emailId)==true)){
      emailIdErMsg = "Email-ID is required.";
      this.isComponentLoaded && this.setState({ "emailIdErMsg": emailIdErMsg});
      totErrCountTrack.push(emailIdErMsg);
    }
    else if(!(this.state.password)||(this.state.password.length==0)){
      passwordErMsg = "Password is required.";
      this.isComponentLoaded && this.setState({ "passwordErMsg": passwordErMsg});
      totErrCountTrack.push(passwordErMsg);
    }
    else if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.state.emailId)==false)
    {
        emailIdErMsg = "Provide a proper Email-ID.";
        this.isComponentLoaded && this.setState({ "emailIdErMsg": emailIdErMsg});
        totErrCountTrack.push(emailIdErMsg);
    }

    if(totErrCountTrack.length>0){
      return false;
    }

    return true;
  }

  handleClick = (event) => {
    event.preventDefault();

    this.isComponentLoaded && this.setState({loaderFlag:true});
    const isValid = this.custValidate();

    if(isValid){
      const creds = { emailId: this.state.emailId, password: this.state.password, killExistingBrowserSession: false };
      let lserv = new UserLoginService();
      lserv.getLoginResp(creds).then(data =>{
          if(data.status==200){
            let tokenRespData = data.data;
            this.isComponentLoaded &&  this.setState({tokenRespData});

            let userInfo = {
                ltoken: custEncode(tokenRespData.access_token),
                expires_at: custEncode(tokenRespData.expires_at),
                refresh_token: custEncode(tokenRespData.refresh_token),
                role: custEncode(tokenRespData.role),
                userId: custEncode(tokenRespData.userId),
              };
              localStorage.setItem("laluser", JSON.stringify(userInfo));

              setTimeout(()=>{

                let luiserv = new LoggedinUserInfoService();
                luiserv.getLoggedInUserInfo({}).then(data =>{

                  let loggedInUserInfoResp = data.data.entity;
                  this.isComponentLoaded &&  this.setState({loggedInUserInfoResp});

                  userInfo.accountStatus = custEncode(loggedInUserInfoResp.accountStatus);
                  userInfo.userEmailId = custEncode(this.state.emailId);
                  userInfo.isOrganisationDetailsProvided = custEncode(loggedInUserInfoResp.isOrganisationDetailsProvided);
                  userInfo.isProfileUpdated = custEncode(loggedInUserInfoResp.isProfileUpdated);
                  userInfo.lastActiveOn = custEncode(loggedInUserInfoResp.lastActiveOn);
                  userInfo.lastLogin = custEncode(loggedInUserInfoResp.lastLogin);
                  userInfo.mobileNumber = custEncode(loggedInUserInfoResp.mobileNumber);
                  userInfo.profilePercentage = custEncode(loggedInUserInfoResp.profilePercentage);
                  userInfo.registeredOn = custEncode(loggedInUserInfoResp.registeredOn);
                  userInfo.role = custEncode(loggedInUserInfoResp.role);
                  userInfo.shouldShowAddUserPopUp = custEncode(loggedInUserInfoResp.shouldShowAddUserPopUp);
                  userInfo.shouldShowOrganisationPopUp = custEncode(loggedInUserInfoResp.shouldShowOrganisationPopUp);
                  userInfo.spaceUsed = custEncode(loggedInUserInfoResp.spaceUsed);
                  userInfo.userId = custEncode(loggedInUserInfoResp.userId);
                  userInfo.userName = custEncode(loggedInUserInfoResp.userName);
                  userInfo.lawFirmName = custEncode(loggedInUserInfoResp.lawFirmName);
                  userInfo.profilePicture = custEncode(loggedInUserInfoResp.profilePicture);

                  let orgObj = loggedInUserInfoResp.organisationDetails!==undefined?loggedInUserInfoResp.organisationDetails:null;

                  userInfo.organisationMaxCapacity = custEncode(orgObj!==null?orgObj.organisationMaxCapacity:null);
                  userInfo.organisationCurrentCapacity = custEncode(orgObj!==null?orgObj.organisationCurrentCapacity:null);

                  let orgLogoObj = (orgObj && orgObj.organisationLogo!==undefined)?orgObj.organisationLogo:null;

                  let filePath = (orgLogoObj!==null && orgLogoObj.filePath!==undefined)? orgLogoObj.filePath:null;
                  userInfo.userImage = custEncode(filePath);

                  let orgName = (orgObj!==null && orgObj.organisationName!==undefined)? orgObj.organisationName:null;
                  userInfo.organisationName = custEncode(orgName);

                  let isSubscriptionActive = (loggedInUserInfoResp.isSubscriptionActive!==undefined && loggedInUserInfoResp.isSubscriptionActive!==null)?loggedInUserInfoResp.isSubscriptionActive: false;
                  let isKycVerified = (loggedInUserInfoResp.isKycVerified!==undefined && loggedInUserInfoResp.isKycVerified!==null)?loggedInUserInfoResp.isKycVerified: false;
                  let isOrganisationKycVerified = (loggedInUserInfoResp.isOrganisationKycVerified!==undefined && loggedInUserInfoResp.isOrganisationKycVerified!==null)?loggedInUserInfoResp.isOrganisationKycVerified: false;

                  let accessObj = {
                    "isSubscriptionActive":isSubscriptionActive,
                    "isKycVerified":isKycVerified,
                    "isOrganisationKycVerified":isOrganisationKycVerified,
                  };

                  accessObj  = custEncode(JSON.stringify(accessObj));
                  userInfo.accessObj = accessObj;

                  localStorage.setItem("laluser", JSON.stringify(userInfo));

                  let succMsg = "Success";
                    notify(succMsg,true,{
                    'successMsg':1,
                    'customWrapClass':'customsuccclass'});
                    removeUserInfoBeforeLogin();
                   setTimeout(()=>{
                        this.props.history.push("/dashboard");
                    },1200);

                }).catch(err=>{
                    //console.log("Some server related tech problem occured",err);
                });

              },250);
            }

      }).catch(err=>{

        let errStatusCodeAr = [400,500,401]; // allowed error status code
        if(err.response && err.response.data){
            let erRespData = err.response.data;
            if(errStatusCodeAr.indexOf(erRespData.status) !== -1){
                let errMsg = (erRespData.message)?erRespData.message:"Some technical problem occurred.";
                notify(errMsg,true,{
                'successMsg':0,
                'customWrapClass':'customerrclass'});
          }
        }

      }).finally(()=>{
        setTimeout(()=>{
          this.isComponentLoaded && this.setState({loaderFlag:false},()=>{
            });
        },1500);

      });
    }else{
      this.isComponentLoaded && this.setState({loaderFlag:false});
    }

  }

  /**
   * Signin
   * Function name : render
   * Author        :
   * Created Date  : 10-2-2020
   * Purpose       : lifecycle method
   * Params        :
  **/
  render(){

      return (
       <>
          <div className="signup_form_area">
                  <div className="sign_up_top">
                    <h1>Sign in</h1>
                    <div className="subheading">
                      Enter your credentials below to sign in
                    </div>
                  </div>
                  <div className="form_area">
                    {/*===  form start === */}
                    <form>
                      <div className="form_block">
                        <div className="panel100 paddingleftright15 tooltip_input_bg">
                          <div className={`form__group field  ${ this.state.emailIdErMsg?'form_group_error':''}`}>
                            <input
                              type="input"
                              className="form__field"
                              placeholder="Organisation Email ID"
                              name="emailId"
                              id="emailId"
                              autoComplete="off"
                              ref='emailId'
                              onChange={ this.handleChange }
                              onKeyDown={(evn)=>{
                                if(evn.keyCode==13){
                                evn.preventDefault();
                                }
                              }}
                            />
                            <label htmlFor="name" className="form__label">
                              Organisation Email ID
                            </label>
                            <span className="error_span">{this.state.emailIdErMsg}</span>
                          </div>
                          <div className="input_tooltip_bg">
                            <span
                              className="input_tooltip"
                              aria-label="Organisation Email ID"
                              data-balloon-pos="down"
                            >
                              <i className="fa fa-question-circle" />
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="form_block">
                        <div className="panel100 paddingleftright15 tooltip_input_bg">
                          <div className={`form__group field  ${ this.state.passwordErMsg?'form_group_error':''}`}>
                            <input
                              type="password"
                              className="form__field"
                              placeholder="Password"
                              name="password"
                              id="password"
                              ref='password'
                              onChange={ this.handleChange }
                              onKeyDown={(evn)=>{
                                if(evn.keyCode==13){
                                evn.preventDefault();
                                }
                              }}
                            />
                            <label htmlFor="name" className="form__label">
                              Password
                            </label>
                            <span className="error_span">{this.state.passwordErMsg}</span>
                          </div>
                        </div>
                      </div>
                      <div className="form_block">
                        <div className="panel100 paddingleftright15 button_ip_panel">
                          <button disabled={this.state.loaderFlag} onClick={(event) => this.handleClick(event)}   type="button" className="btn btn-primary sub_grd_btn">
                            <span>Sign in</span>
                          </button>
                        </div>
                      </div>
                    </form>
                    {/*===  form end === */}
                    {/* ===  login bottm === */}
                    <div className="login_page_bottom">
                      <div className="log_bottm_sec">
                        <p>Don’t have an account?</p>
                        <div className="log_bottom_btn">
                          <button onClick={()=>{this.props.history.push("/signup");}}  className="log_page_btn">
                            <span>Sign up</span>
                          </button>
                        </div>
                      </div>
                    </div>
                    {/* ===  login bottm === */}
                  </div>
                </div>
       </>

      );
  }

}

export default withRouter(Signin);
